import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

import {filter, tap} from 'rxjs/operators';

@Component({
  selector: 'gp-notifications-box',
  templateUrl: './notifications-box.component.html',
  styleUrls: ['../notifications.component.scss']
})

export class NotificationBoxComponent implements OnInit {
  public showDetailView = false;

  constructor(private router: Router) {
  }

  public ngOnInit() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      tap((event: NavigationEnd) =>
        this.showDetailView = event.url.includes('/inbox/notifications') &&
          /\d/.test(event.url))
    ).subscribe();
  }

  public backToList(): void {
    this.router.navigate(['/inbox/notifications']);
  }

}
